module.exports = __webpack_public_path__ + "static/media/item_8_3_comp.02979657.png";